import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const products = [
  {
    id: 'carbon-report-system',
    icon: 'ri-file-chart-line',
    tag: '申报管理',
    badge: '核心产品',
    badgeColor: 'bg-firmai-green/20 text-firmai-green',
    title: '工信部碳排放申报管理系统',
    subtitle: '一键直连官方平台 · 12项功能全覆盖',
    desc: '专为满足工信部《工业企业和园区数字化能碳管理中心建设指南》而设计，完整覆盖12项核心功能，实现与工信部官方申报平台的API直连，零重复填报，全流程合规。',
    features: [
      { icon: 'ri-government-line', title: '官方平台直连', desc: 'API对接工信部官方系统，数据直传' },
      { icon: 'ri-bar-chart-2-line', title: '12项功能全覆盖', desc: '能耗查询到碳资产管理一个平台' },
      { icon: 'ri-robot-2-line', title: 'AI智能核算', desc: '自动识别排放因子，核算零报错' },
      { icon: 'ri-file-list-3-line', title: '合规报告一键生成', desc: '符合工信部格式，5分钟内完成' },
      { icon: 'ri-alarm-warning-line', title: '履约预警提醒', desc: '申报截止自动提醒，不错过时限' },
      { icon: 'ri-shield-check-line', title: '区块链存证', desc: '数据不可篡改，核查有保障' },
    ],
    specs: ['支持 Windows/Mac/Linux', 'SaaS云端部署 / 本地私有化', '支持API接口对接', '多用户权限分级管理', '数据导出 Excel/PDF/XML'],
    price: '联系报价',
    image: 'https://readdy.ai/api/search-image?query=enterprise%20carbon%20emission%20reporting%20management%20system%20dashboard%20dark%20interface%20professional%20compliance%20software%20Chinese%20manufacturing%20industry%20energy%20data%20visualization%20modern%20UI&width=580&height=360&seq=prod1&orientation=landscape',
  },
  {
    id: 'industrial-ai-platform',
    icon: 'ri-cpu-line',
    tag: 'AI智能',
    badge: '热门产品',
    badgeColor: 'bg-cyan-500/20 text-cyan-400',
    title: '工业AI智能管控平台',
    subtitle: '设备预测运维 · 视觉质检 · 数字孪生',
    desc: '将工业AI深度落地工厂实景，覆盖生产工艺优化、设备预测性运维、AI视觉质检、能耗管控、数字孪生五大核心场景，实现工厂智能化全链路升级。',
    features: [
      { icon: 'ri-line-chart-line', title: '设备预测性运维', desc: '提前30天预测故障，减少非计划停机' },
      { icon: 'ri-eye-line', title: 'AI视觉质检', desc: '缺陷自动识别，准确率99%以上' },
      { icon: 'ri-leaf-line', title: '能耗智能管控', desc: 'AI实时优化能源分配，节能35%' },
      { icon: 'ri-scan-2-line', title: '数字孪生工厂', desc: '3D虚拟工厂建模，实时镜像运行状态' },
      { icon: 'ri-video-line', title: '安全生产监控', desc: 'AI识别违规行为，实时预警推送' },
      { icon: 'ri-settings-4-line', title: '工艺AI优化', desc: '自动调整工艺参数，提升产品质量' },
    ],
    specs: ['边缘计算 + 云端协同架构', '支持主流PLC/SCADA对接', '摄像头/传感器即插即用', '自定义AI模型训练', '移动端实时监控App'],
    price: '定制报价',
    image: 'https://readdy.ai/api/search-image?query=industrial%20AI%20smart%20factory%20control%20platform%20multiple%20screens%20robotic%20arms%20digital%20twin%203D%20visualization%20quality%20inspection%20cameras%20IoT%20sensors%20modern%20technology%20professional%20dark%20themed&width=580&height=360&seq=prod2&orientation=landscape',
  },
  {
    id: 'ccer-cbam-system',
    icon: 'ri-database-2-line',
    tag: 'CCER/CBAM',
    badge: '合规专用',
    badgeColor: 'bg-violet-500/20 text-violet-400',
    title: 'CCER/CBAM合规填报数据系统',
    subtitle: '国家注册系统直连 · 欧盟CBAM合规',
    desc: '专为CCER全国温室气体自愿减排和CBAM欧盟碳边境调节机制设计的专业合规数据系统，支持直连国家注册登记平台，自动化完成数据归集、核算、填报全流程。',
    features: [
      { icon: 'ri-global-line', title: 'CCER系统直连', desc: '直连全国温室气体自愿减排注册登记系统' },
      { icon: 'ri-ship-line', title: 'CBAM合规填报', desc: '欧盟海关系统对接，自动生成填报材料' },
      { icon: 'ri-calculator-line', title: '产品碳足迹核算', desc: 'LCA全生命周期核算，符合ISO 14067' },
      { icon: 'ri-archive-line', title: '合规材料归档', desc: '自动整理归档所有核查证明材料' },
      { icon: 'ri-refresh-line', title: '政策实时更新', desc: '跟踪最新CCER/CBAM政策变化' },
      { icon: 'ri-exchange-line', title: '数据格式标准化', desc: '自动转换符合各平台要求的数据格式' },
    ],
    specs: ['支持20+排放源数据接入', '15+套CCER核算方法学', '欧盟CBAM官方格式输出', '多语言报告生成（中/英）', '云端SaaS快速上手'],
    price: '联系报价',
    image: 'https://readdy.ai/api/search-image?query=CCER%20CBAM%20carbon%20compliance%20data%20system%20professional%20dashboard%20registration%20platform%20carbon%20credits%20management%20global%20carbon%20trading%20professional%20dark%20interface%20modern%20enterprise&width=580&height=360&seq=prod3&orientation=landscape',
  },
  {
    id: 'blockchain-ledger',
    icon: 'ri-links-line',
    tag: '区块链存证',
    badge: '安全合规',
    badgeColor: 'bg-amber-500/20 text-amber-400',
    title: '企业碳台账区块链存证系统',
    subtitle: '不可篡改 · 核查无忧 · 多权限管理',
    desc: '基于区块链技术构建企业碳排放台账存证系统，所有碳排放原始数据上链存证，确保数据真实性与不可篡改性，为第三方核查和官方审计提供完整可追溯的数字化证据链。',
    features: [
      { icon: 'ri-lock-2-line', title: '区块链不可篡改', desc: '所有数据上链，确保真实性与完整性' },
      { icon: 'ri-search-eye-line', title: '完整审计轨迹', desc: '每次数据操作均有完整记录可追溯' },
      { icon: 'ri-team-line', title: '多权限分级管理', desc: '企业不同部门独立账号，权限精细控制' },
      { icon: 'ri-qr-code-line', title: '数字证书签发', desc: '每批数据生成唯一数字存证证书' },
      { icon: 'ri-file-shield-2-line', title: '核查材料自动打包', desc: '一键生成第三方核查所需全套材料' },
      { icon: 'ri-cloud-line', title: '多云存储备份', desc: '三地灾备，数据安全永不丢失' },
    ],
    specs: ['联盟链架构（可私有化）', '符合国家数据安全标准', '支持与现有系统集成', 'API接口完整开放', '司法机构认可的存证效力'],
    price: '定制报价',
    image: 'https://readdy.ai/api/search-image?query=blockchain%20carbon%20ledger%20digital%20certification%20system%20secure%20data%20storage%20distributed%20ledger%20technology%20nodes%20connected%20glowing%20network%20dark%20background%20professional%20tech%20modern%20visualization&width=580&height=360&seq=prod4&orientation=landscape',
  },
  {
    id: 'energy-monitor',
    icon: 'ri-line-chart-line',
    tag: '能耗监测',
    badge: '实时监控',
    badgeColor: 'bg-teal-500/20 text-teal-400',
    title: '工业能耗AI监测分析系统',
    subtitle: 'IoT实时采集 · AI分析预测 · 节能优化',
    desc: '基于IoT传感器和工业级数据采集设备，实现工厂全场景能耗数据毫秒级实时监测，结合AI深度学习模型，提供能耗预测、异常诊断、节能策略推荐等智能化分析服务。',
    features: [
      { icon: 'ri-wifi-line', title: 'IoT全场景接入', desc: '电/气/热/水多种能源类型统一监测' },
      { icon: 'ri-dashboard-line', title: '实时大屏展示', desc: '毫秒级数据刷新，可视化大屏展示' },
      { icon: 'ri-brain-line', title: 'AI能耗预测', desc: '提前72小时预测能耗峰值，准确率95%+' },
      { icon: 'ri-alert-line', title: '异常智能诊断', desc: '自动识别能耗异常，实时推送告警' },
      { icon: 'ri-lightbulb-line', title: '节能策略推荐', desc: 'AI推荐峰谷调度、设备调参等节能方案' },
      { icon: 'ri-file-list-3-line', title: '合规报表生成', desc: '自动生成工信部要求的能耗统计报表' },
    ],
    specs: ['支持1000+测量点接入', 'MQTT/ModBus/OPC-UA协议', '历史数据存储5年以上', '移动端实时查看App', '支持离线断网续传'],
    price: '联系报价',
    image: 'https://readdy.ai/api/search-image?query=industrial%20energy%20consumption%20AI%20monitoring%20analysis%20dashboard%20real%20time%20IoT%20sensors%20factory%20electricity%20gas%20heat%20water%20measurement%20modern%20dark%20interface%20professional%20enterprise&width=580&height=360&seq=prod5&orientation=landscape',
  },
];

export default function ProductsPage() {
  const navigate = useNavigate();
  const [activeProduct, setActiveProduct] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);
  const current = products[activeProduct];

  const handleSelect = (idx: number) => {
    setActiveProduct(idx);
    setTimeout(() => {
      contentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-28 pb-14 overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,217,163,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }} />
          </div>
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10 text-center">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-5">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-apps-2-line" /></span>
              工业双碳+AI智能化产品矩阵
            </span>
            <h1 className="font-display font-bold text-3xl md:text-5xl text-white mb-4">
              五大核心产品<br />
              <span className="bg-gradient-to-r from-firmai-green to-teal-400 bg-clip-text text-transparent">覆盖工业能碳管理全场景</span>
            </h1>
            <p className="text-firmai-text text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
              从工信部碳排申报到CCER/CBAM合规，从工业AI智能化到能耗实时监测，Firmai产品矩阵为工业企业提供完整的数字化解决方案
            </p>
          </div>
        </section>

        {/* Products */}
        <section className="pb-20 bg-firmai-darker">
          <div className="w-full px-4 md:px-8 lg:px-12">
            {/* Sidebar + Content */}
            <div className="flex flex-col lg:flex-row gap-6">
              {/* Sidebar */}
              <div className="lg:w-64 shrink-0">
                <div className="bg-firmai-card border border-firmai-border rounded-xl overflow-hidden sticky top-24">
                  {products.map((p, idx) => (
                    <button
                      key={p.id}
                      onClick={() => handleSelect(idx)}
                      className={`w-full flex items-center gap-3 px-4 py-3.5 text-left transition-all duration-200 cursor-pointer border-b border-firmai-border last:border-b-0 ${
                        activeProduct === idx
                          ? 'bg-firmai-green/10 border-l-2 border-l-firmai-green'
                          : 'hover:bg-white/5'
                      }`}
                    >
                      <span className={`w-8 h-8 flex items-center justify-center rounded-lg shrink-0 ${activeProduct === idx ? 'bg-firmai-green/20 text-firmai-green' : 'bg-firmai-dark text-firmai-muted'}`}>
                        <i className={p.icon} />
                      </span>
                      <div>
                        <div className={`text-xs font-medium leading-snug ${activeProduct === idx ? 'text-white' : 'text-firmai-text'}`}>{p.title.substring(0, 12)}...</div>
                        <div className="text-firmai-muted text-xs mt-0.5">{p.tag}</div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Main Content */}
              <div className="flex-1 min-w-0" ref={contentRef}>
                <div className="bg-firmai-card border border-firmai-border rounded-xl overflow-hidden">
                  {/* Product Image */}
                  <div className="h-56 md:h-72 w-full overflow-hidden">
                    <img src={current.image} alt={current.title} className="w-full h-full object-cover object-top" />
                  </div>

                  <div className="p-6 md:p-8">
                    <div className="flex flex-wrap items-center gap-2 mb-4">
                      <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${current.badgeColor}`}>{current.badge}</span>
                      <span className="px-2.5 py-1 rounded-full text-xs bg-firmai-dark text-firmai-muted border border-firmai-border">{current.tag}</span>
                    </div>
                    <h2 className="text-white font-bold text-xl md:text-2xl mb-2">{current.title}</h2>
                    <p className="text-firmai-green text-sm font-medium mb-4">{current.subtitle}</p>
                    <p className="text-firmai-text text-sm md:text-base leading-relaxed mb-6">{current.desc}</p>

                    {/* Features Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6">
                      {current.features.map((f) => (
                        <div key={f.title} className="bg-firmai-dark border border-firmai-border rounded-lg p-3.5 hover:border-firmai-green/30 transition-colors duration-200">
                          <div className="flex items-center gap-2 mb-1.5">
                            <span className="w-5 h-5 flex items-center justify-center text-firmai-green">
                              <i className={f.icon} />
                            </span>
                            <span className="text-white text-sm font-medium">{f.title}</span>
                          </div>
                          <p className="text-firmai-muted text-xs leading-relaxed">{f.desc}</p>
                        </div>
                      ))}
                    </div>

                    {/* Specs */}
                    <div className="bg-firmai-dark border border-firmai-border rounded-lg p-4 mb-6">
                      <h3 className="text-firmai-muted text-xs font-semibold uppercase tracking-wider mb-3">技术规格</h3>
                      <div className="flex flex-wrap gap-2">
                        {current.specs.map((s) => (
                          <span key={s} className="px-3 py-1 bg-firmai-card border border-firmai-border rounded-full text-xs text-firmai-text">
                            {s}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                      <div>
                        <div className="text-firmai-muted text-xs">产品价格</div>
                        <div className="text-firmai-green font-bold text-lg">{current.price}</div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <a
                          href="/contact"
                          onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                          className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
                        >
                          申请演示
                        </a>
                        <a
                          href="/contact"
                          onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                          className="inline-flex items-center justify-center gap-2 px-6 py-2.5 border border-firmai-border text-firmai-text font-medium rounded-md hover:border-firmai-green/40 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
                        >
                          获取报价
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}